import HomeView from '../views/home-view.vue';
import ImprintView from '../views/imprint-view.vue';
import DataProtectionView from '../views/data-protection-view.vue';
import NotFound from '../views/not-found-view.vue';
import { menuItemType } from '../types/menu-types';

export async function getMenus() {
  const headerMenu: menuItemType[] = [];

  headerMenu.push(
    {
      name: 'Informationen',
      path: '/',
      component: HomeView,
      submenu: [],
      props: {
        title: 'Informationen'
      }
    },
    {
      name: 'Impressum',
      path: '/impressum',
      component: ImprintView,
      submenu: [],
      props: {
        title: 'Impressum'
      }
    },
    {
      name: 'Datenschutz',
      path: '/datenschutz',
      component: DataProtectionView,
      submenu: [],
      props: {
        title: 'Datenschutz'
      }
    }
  );

  const abstract = [
    {
      path: '/:pathMatch(.*)*',
      name: 'Fehler',
      component: NotFound
    }
  ];

  return {
    header: headerMenu,
    abstract: abstract
  };
}
